// src/components/Layout.jsx
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Header />
      <main style={{ flex: 1, overflow: "hidden" }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
